import React from "react";
import { ThumbnailView, EditableField, Modal } from "../../components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isEmpty, set, merge } from "lodash";
import cn from "classnames";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import selectors from "./selectors";
import moment from "moment";
import actions from "../../actions";
import { AWS_STATIC_ENDPOINT } from "../../../../../common/constants";

class PostDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      post: {},
      post_original: {},

      query: {},
      related_posts: [],
      other_posts: [],
      thumb_id: -1,
      remove_media_ids: [],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClickItem = this.handleClickItem.bind(this);
    this.onChangePostImage = this.onChangePostImage.bind(this);
    this.onAddPostImage = this.onAddPostImage.bind(this);
    this.removeMedia = this.removeMedia.bind(this);
    this.editMedia = this.editMedia.bind(this);
    this.onAddMoreImage = this.onAddMoreImage.bind(this);
  }

  componentDidMount() {
    const {
      getPostDetail,
      match: {
        params: { id },
      },
      match,
    } = this.props;
    this.setState({
      loading: true,
    });
    getPostDetail(id)
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            post: data.data.post,
            post_original: data.data.post,
            related_posts: data.data.related_posts,
            other_posts: data.data.other_posts,
          });
        } else {
          toast.error("Failed to get Post Detail");
        }
        this.setState({
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        toast.error("Internal Server Error");
      });
  }

  onAddPostImage(e) {
    let {
      query,
      post,
      post: { mediaInfo },
    } = this.state;
    const thumbnail = e.target.files[0];
    const type = thumbnail.type;
    let reader = new FileReader();
    reader.onloadend = (el) => {
      mediaInfo.push({
        media_file: el.target.result,
        media_type: type,
        thumbnail: thumbnail,
      });

      let mediaFiles = [];
      for (let i = 0; i < mediaInfo.length; i += 1) {
        if (!mediaInfo[i]._id) mediaFiles.push(mediaInfo[i].thumbnail);
      }

      if (mediaFiles.length > 0) set(query, "mediaInfo", mediaFiles);
      set(post, "mediaInfo", mediaInfo);
      this.setState({ query, post });
    };

    reader.readAsDataURL(thumbnail);
  }

  onChangePostImage(e) {
    let {
      query,
      post,
      post: { mediaInfo },
      thumb_id,
      remove_media_ids,
    } = this.state;
    const thumbnail = e.target.files[0];
    const type = thumbnail.type;
    let reader = new FileReader();
    reader.onloadend = (el) => {
      if (thumb_id < 0) {
        mediaInfo.push({
          media_file: el.target.result,
          media_type: type,
          thumbnail: thumbnail,
        });
      } else {
        if (remove_media_ids.findIndex((el) => el === mediaInfo[thumb_id]._id))
          remove_media_ids.push(mediaInfo[thumb_id]._id);
        mediaInfo[thumb_id] = {
          media_file: el.target.result,
          media_type: type,
          thumbnail: thumbnail,
        };
      }

      let mediaFiles = [];
      for (let i = 0; i < mediaInfo.length; i += 1) {
        if (!mediaInfo[i]._id) mediaFiles.push(mediaInfo[i].thumbnail);
      }

      if (mediaFiles.length > 0) set(query, "mediaInfo", mediaFiles);
      set(post, "mediaInfo", mediaInfo);

      this.setState({ query, post, remove_media_ids });
    };

    reader.readAsDataURL(thumbnail);
  }

  removeMedia() {
    let {
      thumb_id,
      post,
      post: { mediaInfo },
      query,
      remove_media_ids,
    } = this.state;
    remove_media_ids.push(mediaInfo[thumb_id]._id);

    mediaInfo = mediaInfo.splice(thumb_id, 1);
    let mediaFiles = [];
    for (let i = 0; i < mediaInfo.length; i += 1) {
      if (!mediaInfo[i]._id) mediaFiles.push(mediaInfo[i].media_file);
    }
    if (mediaFiles.length > 0) set(query, "mediaInfo", mediaFiles);
    set(post, "mediaInfo", mediaInfo);

    if (remove_media_ids.length > 0) {
      set(query, "remove_media_ids", remove_media_ids);
    }

    this.setState({ query, post, remove_media_ids });
  }

  editMedia() {
    this.fileInput.click();
  }

  onAddMoreImage() {
    this.addfileInput.click();
  }

  handleSave() {
    const {
      updatePost,
      match: {
        params: { id },
      },
    } = this.props;
    const { query, remove_media_ids } = this.state;

    if (remove_media_ids.length > 0) {
      set(query, "remove_media_ids", JSON.stringify(remove_media_ids));
    }

    updatePost(id, query)
      .then(({ result: { data } }) => {
        if (data.result === "success") {
          this.setState({
            query: {},
            post_original: this.state.post,
          });
          toast.success("Succeed to update plan");
        } else if (data.result === "error") {
          toast.error("Failed to update the trip plan");
        }
      })
      .catch(() => toast.error("Internal Server Error"));
  }

  handleCancel() {
    this.setState({
      query: {},
      post: this.state.post_original,
    });
  }

  handleInputChange({ target: { id, value } }) {
    let { post, query } = this.state;

    set(post, id, value);
    set(query, id, value);

    this.setState({ post, query });
  }

  handleClickItem(index) {
    $(`#image_modal`).modal("show");
    this.setState({
      thumb_id: index,
    });
  }

  renderPostImages() {
    const {
      post: { mediaInfo },
    } = this.state;
    return (
      <ThumbnailView images={mediaInfo} onClickItem={this.handleClickItem} />
    );
  }

  renderImageModal() {
    const {
      thumb_id,
      post: { mediaInfo },
    } = this.state;

    return (
      <Modal id="image_modal">
        <div className="modal-content modal-image-content">
          <img
            src={
              mediaInfo && mediaInfo[thumb_id]
                ? mediaInfo[thumb_id].media_file
                : ""
            }
            className="cover"
            width="242"
            height="363"
          ></img>
          <div className="post-media-control">
            <span
              className="fa fa-trash remove-media-but"
              onClick={this.removeMedia}
            ></span>
            <span
              className="fa fa-edit edit-media-but"
              onClick={this.editMedia}
            ></span>
          </div>
        </div>
      </Modal>
    );
  }

  renderPostDetail() {
    const { post, query } = this.state;
    if (!post || isEmpty(post)) return null;
    return (
      <div className="card post-detail-card">
        <div className="card-body">
          <div className="row post-info-container">
            <div className="col-5">
              <label>Title</label>
            </div>
            <div className="col-7 info-item">
              <EditableField>
                <div>
                  <div className="hide-on-edit static-value">
                    <span className="static-field">{post.title}</span>
                  </div>
                  <input
                    type="text"
                    className="dark-input sm-input show-on-edit input-field"
                    value={post.title}
                    placeholder="Title"
                    id="title"
                    onChange={this.handleInputChange}
                  />
                  <div className="action" />
                </div>
              </EditableField>
            </div>
          </div>
          <div className="row post-info-container">
            <div className="col-5">
              <label>Description</label>
            </div>
            <div className="col-7 info-item">
              <EditableField>
                <div>
                  <div className="hide-on-edit static-value">
                    <span className="static-field">{post.description}</span>
                  </div>
                  <input
                    type="text"
                    className="dark-input sm-input show-on-edit input-field"
                    value={post.description}
                    placeholder="Description"
                    id="description"
                    onChange={this.handleInputChange}
                  />
                  <div className="action" />
                </div>
              </EditableField>
            </div>
          </div>
          <div className="row post-info-container">
            <div className="col-5">
              <label>Price</label>
            </div>
            <div className="col-7 info-item">
              <EditableField>
                <div>
                  <div className="hide-on-edit static-value">
                    <span className="static-field">{post.price}</span>
                  </div>
                  <input
                    type="text"
                    className="dark-input sm-input show-on-edit input-field"
                    value={post.price}
                    placeholder="Price"
                    id="price"
                    onChange={this.handleInputChange}
                  />
                  <div className="action" />
                </div>
              </EditableField>
            </div>
          </div>
          <div className="row post-info-container">
            <div className="col-5">
              <label>Currency</label>
            </div>
            <div className="col-7 info-item">
              <EditableField>
                <div>
                  <div className="hide-on-edit static-value">
                    <span className="static-field">{post.currency}</span>
                  </div>
                  <input
                    type="text"
                    className="dark-input sm-input show-on-edit input-field"
                    value={post.currency}
                    placeholder="Currency"
                    id="currency"
                    onChange={this.handleInputChange}
                  />
                  <div className="action" />
                </div>
              </EditableField>
            </div>
          </div>
          <div className="row post-info-container">
            <div className="col-5">
              <label>Time Limit</label>
            </div>
            <div className="col-7 info-item">
              <EditableField>
                <div>
                  <div className="hide-on-edit static-value">
                    <span className="static-field">
                      {moment(post.time_limit).format("YYYY-MM-DDTHH:MM:SS")}
                    </span>
                  </div>
                  <input
                    type="datetime-local"
                    className="dark-input sm-input show-on-edit input-field date-picker"
                    value={moment(post.time_limit).format(
                      "YYYY-MM-DDTHH:MM:SS"
                    )}
                    id="time_limit"
                    onChange={this.handleInputChange}
                  />
                  <div className="action" />
                </div>
              </EditableField>
            </div>
          </div>
          <div className="row post-info-container">
            <div className="col-6">
              <div className="post-value">
                <label>View Counts</label>
                {post.views}
              </div>
            </div>
            <div className="col-6">
              <div className="post-value">
                <label>Likes Counts</label>
                {post.likes}
              </div>
            </div>
          </div>

          <div className="row post-info-container">
            <div className="col-6">
              <div
                className="btn btn-priamry add-more-image"
                onClick={this.onAddMoreImage}
              >
                Add More Image
              </div>
              <input
                type="file"
                className="d-none"
                accept="image/x-png,image/jpg,image/jpeg"
                onChange={this.onAddPostImage}
                ref={(ref) => (this.addfileInput = ref)}
              />
            </div>
            <div className="col-6"></div>
          </div>
        </div>
        {isEmpty(query) ? null : (
          <div className="card-footer">
            <button
              className="btn btn-primary manage-profile-but"
              onClick={this.handleSave}
            >
              {"Save"}
            </button>
            <button
              className="btn btn-outline manage-profile-but"
              onClick={this.handleCancel}
            >
              {"Cancel"}
            </button>
          </div>
        )}
      </div>
    );
  }

  renderOwnwerInfo() {
    const {
      post: { customerInfo },
    } = this.state;
    if (!customerInfo) return null;
    return (
      <div className="card user-detail-card">
        <div className="card-body">
          <div className="row info-item">
            <div className="col-12">
              <div className="info-title">User Description</div>
            </div>
          </div>
          <div className="row info-item">
            <div className="col-6">
              <label>Username</label>
            </div>
            <div className="col-6">
              <span className="static-field">{customerInfo.username}</span>
            </div>
          </div>
          <div className="row info-item">
            <div className="col-6">
              <label>Email</label>
            </div>
            <div className="col-6">
              <span className="static-field">{customerInfo.email}</span>
            </div>
          </div>
          <div className="row info-item">
            <div className="col-6">
              <label>Display Name</label>
            </div>
            <div className="col-6">
              <span className="static-field">{customerInfo.display_name}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPostThumbnail(mediaInfo) {
    if (mediaInfo.length > 0) {
      if (mediaInfo[0].media_type === "image")
        return (
          <img
            className="related-post-item-image"
            src={mediaInfo[0].media_file}
            height={200}
          ></img>
        );
      else if (mediaInfo[0].media_type === "video")
        return (
          <img
            className="related-post-item-image"
            src={mediaInfo[0].thumbnail}
            height={200}
          ></img>
        );
    }
    return (
      <img
        className="related-post-item-image"
        src={AWS_STATIC_ENDPOINT + "/images/share_logo"}
        height={200}
      ></img>
    );
  }

  renderRelatedPosts() {
    const { related_posts } = this.state;
    if (!related_posts || related_posts.length == 0) return null;
    return (
      <div className="row">
        {related_posts.map((item, key) => {
          return (
            <div className="col-12 col-sm-3" key={key}>
              <div className="related-post-item">
                {this.renderPostThumbnail(item.mediaInfo)}
                <div className="related-post-item-description">
                  {item.description}
                </div>
                <div className="related-post-item-value">
                  <div className="related-post-item-price">
                    {item.price
                      ? "Price " +
                        item.price +
                        " " +
                        item.currency.toUpperCase()
                      : null}
                  </div>
                  <div className="related-post-item-time-limit">
                    {moment(item.time_limit).format("YYYY-MM-DD")}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderImageModal()}

        <div className="row justify-content-center">
          <div className="col-12 col-sm-4">
            {this.renderPostImages()}
            <input
              type="file"
              className="d-none"
              accept="image/x-png,image/jpg,image/jpeg"
              onChange={this.onChangePostImage}
              ref={(ref) => (this.fileInput = ref)}
            />
          </div>
          <div className="col-12 col-sm-5">{this.renderPostDetail()}</div>
          <div className="col-12 col-sm-3">{this.renderOwnwerInfo()}</div>
        </div>
        <div className="post-items-title">Related Posts</div>
        {this.renderRelatedPosts()}
        <div className="post-items-title">Recent Posts by the user</div>
        {this.renderRelatedPosts()}
      </React.Fragment>
    );
  }
}

PostDetail.propTypes = {
  getPostDetail: PropTypes.func,
  updatePost: PropTypes.func,
};

export default connect(selectors, {
  ...actions.posts,
})(withRouter(PostDetail));



// WEBPACK FOOTER //
// ./client/react/Admin/views/PostDetail/index.js